// ////////////////////////////スマホ/タブレット判別
var _ua = (function (u) {
  return {
    Tablet:
      (u.indexOf('windows') != -1 && u.indexOf('touch') != -1) ||
      u.indexOf('ipad') != -1 ||
      (u.indexOf('android') != -1 && u.indexOf('mobile') == -1) ||
      (u.indexOf('firefox') != -1 && u.indexOf('tablet') != -1) ||
      u.indexOf('kindle') != -1 ||
      u.indexOf('silk') != -1 ||
      u.indexOf('playbook') != -1,
    Mobile:
      (u.indexOf('windows') != -1 && u.indexOf('phone') != -1) ||
      u.indexOf('iphone') != -1 ||
      u.indexOf('ipod') != -1 ||
      (u.indexOf('android') != -1 && u.indexOf('mobile') != -1) ||
      (u.indexOf('firefox') != -1 && u.indexOf('mobile') != -1) ||
      u.indexOf('blackberry') != -1,
  };
})(window.navigator.userAgent.toLowerCase());
// if(_ua.Mobile){}

var osVer;
osVer = 'Android';

var ua = navigator.userAgent.toLowerCase();
var iPadFlag = false;
if (/android|ipod|ipad|iphone|macintosh/.test(ua) && 'ontouchend' in document) {
  iPadFlag = true;
  $('#wrapper').addClass('setTouch');
}
// if (navigator.userAgent.indexOf(osVer)>0){
// }

var breakNum = 768;
var tabletNum = 1024;

// ////////////////////////////////////init
// $(function () {
//   // setScroll();
//   // if ($('#wrapper').hasClass('home')) {
//   //   setWave();
//   // }
//   // ///////////
//   // if (!_ua.Mobile && !_ua.Tablet) {
//   //   $('#wrapper').addClass('desktop');
//   //   if (!$('#wrapper').hasClass('about')) {
//   //     $('html, body').prop({
//   //       scrollTop: 0,
//   //     });
//   //     if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1 && ua.indexOf('edge') === -1) {
//   //       // ここにSafari用の記述
//   //     } else {
//   //     }
//   //   }
//   // }
//   // ///////////
// });

$(window).on('load', function () {
  judgeWinSize();
  setHeader();
  // setGnav();
  setSpan();
  // setInview();
  setAcc();
  // setMegaMenu();
  startScroll();
  setMainMenu();
  setCartModal();
  setLoaded();
  if ($('#wrapper').hasClass('home')) {
    setSlider_01();
    randomKv();
  } else if ($('#wrapper').hasClass('single-product')) {
    setSlider_02();
    setSlider_03();
  } else if ($('#wrapper').hasClass('subscription')) {
    selectSubscription();
  } else if ($('#wrapper').hasClass('about-us')) {
    setSlider_03();
  }
  if ($('#container').hasClass('set30')) {
    setPaywhirl30();
  } else if ($('#container').hasClass('set33')) {
    setPaywhirl33();
  }
  setPolicyTitle();
  setCoupon();
  setWay();
  setPassReminder();
});

////画像のランダム更新
function randomKv() {
  var items = document.querySelectorAll('.imgList li'); // .imgList 内のすべての li 要素を取得
  if (items.length > 0) {
    // 既に .active クラスを持つ要素があれば、そのクラスを削除
    items.forEach(function (item) {
      item.classList.remove('active');
    });

    // ランダムな要素を選択して .active クラスを追加
    var randomIndex = Math.floor(Math.random() * items.length);
    items[randomIndex].classList.add('active');
  }
}

//クーポンコピー
function setCoupon() {
  $('.couponBtn').on('click', function () {
    // コピーする文章の取得
    let text = $('.couponTx').val();
    if (navigator.clipboard == undefined) {
      window.clipboardData.setData('Text', text);
    } else {
      navigator.clipboard.writeText(text);
    }
  });
}

//setPolicyTitle
function setPolicyTitle() {
  if ($('.shopify-policy__title h1').length) {
    console.log('aa');
    $('.shopify-policy__title h1').text('PRIVACY POLICY');
  }
}

//Paywhirlのフォーマット改変
function setPaywhirl30() {
  const basePrice = Number(
    $('.paywhirl-compare-at-price').text().replace('¥', '').replace(',', '')
  );
  let price = Math.round(basePrice * 0.7);
  price = '¥' + String(price).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  $('.paywhirl-price').text(price);
  $('.paywhirl-price').show();
  $('.paywhirl-price').addClass('is-active');
  $('input[name="paywhirl-plan-selector-group"]').on('change', function () {
    $('.paywhirl-price').css('opacity', '0');
    setTimeout(function () {
      $('.paywhirl-price').text(price);
      $('.paywhirl-price').addClass('is-active');
      $('.paywhirl-price').css('opacity', '1');
      $('.paywhirl-price').fadeIn();
    }, 100);
  });
}

function setPaywhirl33() {
  const basePrice = Number(
    $('.paywhirl-compare-at-price').text().replace('¥', '').replace(',', '')
  );
  let price = Math.floor(basePrice * 0.67);
  price = '¥' + String(price).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  $('.paywhirl-price').text(price);
  $('.paywhirl-price').show();
  $('.paywhirl-price').addClass('is-active');
  $('input[name="paywhirl-plan-selector-group"]').on('change', function () {
    $('.paywhirl-price').css('opacity', '0');
    setTimeout(function () {
      $('.paywhirl-price').text(price);
      $('.paywhirl-price').addClass('is-active');
      $('.paywhirl-price').css('opacity', '1');
      $('.paywhirl-price').fadeIn();
    }, 100);
  });
}

//サブスクアイテムセレクト
function selectSubscription() {
  const itemLink = $('input[name=item-select]:checked').val();
  $('#selectItemBtn').attr('href', itemLink);
  $('[name=item-select]').click(function () {
    const itemLink = $('input[name=item-select]:checked').val();
    const index = $('.radioStyle_02>span').index($(this).parents('span')) + 1;
    const target = '#item_' + index;
    $('#selectItemBtn').attr('href', itemLink);
    $('.selectableItems .item').removeClass('active');
    $(target).addClass('active');
  });
}

var current_scrollY = 0;
// //////////////////////////カートボタン
function setCartModal() {
  $('#cartBtn button').on('click', function () {
    current_scrollY = $(window).scrollTop();
    $('#wrapper').addClass('cartOpen');
    const winW = $(window).width();
    if (winW <= breakNum) {
      $('#outerMenu').css('top', -current_scrollY);
      setTimeout(function () {
        $('html, body').prop({
          scrollTop: 0,
        });
      }, 100);
    }
  });
  $('.closeCartArea,#cartCloseBtn').on('click', function () {
    $('#wrapper').removeClass('cartOpen');
    if (winW <= breakNum) {
      $('#outerMenu').css('top', '');
      $('html, body').prop({
        scrollTop: current_scrollY,
      });
    }
  });
  // if ($('#wrapper').hasClass('setPc')) {
  // }
  var winW = $(window).width();
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    winW = $(window).width();
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearInterval(timer);
    }
    timer = setTimeout(function () {
      $('#wrapper').removeClass('cartOpen');
      if ($('#wrapper').hasClass('setSp')) {
        $('#outerMenu').css('top', '');
        $('html, body').prop({
          scrollTop: current_scrollY,
        });
      }
    }, 200);
  });
}

// カルーセル
function setSlider_01() {
  const mySwiperMain = new Swiper('.carouselStyle_01 .swiper-main', {
    slidesPerView: 1,
    spaceBetween: -80,
    // preventClicks: false,
    // preventClicksPropagation: false,
    mousewheel: {
      forceToAxis: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    speed: 1000, // スライドアニメーションのスピード（ミリ秒）
    breakpoints: {
      769: {
        slidesPerView: 2.5,
        spaceBetween: 30,
      },
      1000: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });
}

function setSlider_02() {
  const mySwiperMain = new Swiper('.carouselStyle_02 .swiper-main', {
    slidesPerView: 1,
    preventClicks: false,
    preventClicksPropagation: false,
    // effect: 'fade',
    // spaceBetween: -80,
    mousewheel: {
      forceToAxis: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    navigation: {
      nextEl: '.area-next',
      prevEl: '.area-prev',
    },
    speed: 1000, // スライドアニメーションのスピード（ミリ秒）
  });
}

function setSlider_03() {
  const mySwiperMain = new Swiper('.carouselStyle_03 .swiper-main', {
    slidesPerView: 2.2,
    preventClicks: false,
    preventClicksPropagation: false,
    // spaceBetween: -80,
    mousewheel: {
      forceToAxis: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    speed: 1000, // スライドアニメーションのスピード（ミリ秒）
    breakpoints: {
      // スライドの表示枚数：500px以上の場合
      769: {
        slidesPerView: 5,
        // spaceBetween: 0,
        scrollbar: {
          enabled: false,
        },
      },
    },
  });
}

// //////////////////////////メインメニュー
function setMainMenu() {
  $('#mainMenu').hover(
    function () {
      if ($('#wrapper').hasClass('setPc')) {
        $(this).stop().addClass('active');
        $('#hoverMenu .navAll').stop().slideDown('fast');
      }
    },
    function () {
      if ($('#wrapper').hasClass('setPc')) {
        $(this).removeClass('active');
        $('#hoverMenu .navAll').stop().slideUp('fast');
      }
    }
  );
  $('#mainMenu').on('click', function () {
    if ($('#wrapper').hasClass('setSp')) {
      if (!$('#mainMenu').hasClass('active')) {
        openFnc();
      } else {
        closeFnc();
      }
    }
  });
  $('#clickBlocker,#menuPanel .closeBtn,#menuPanel .closeArea,#menuPanel .mainNav').on(
    'click',
    function (event) {
      event.stopPropagation();
      closeFnc();
    }
  );

  $('.mainNav a').on('click', function (event) {
    event.stopPropagation();
  });

  var winW = $(window).width();
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    winW = $(window).width();
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearInterval(timer);
    }
    timer = setTimeout(function () {
      if (winW > tabletNum) {
        closeFnc();
      }
    }, 200);
  });
}

function openFnc() {
  current_scrollY = $(window).scrollTop();
  $('#mainMenu').addClass('active');
  $('#wrapper').addClass('menuOpen');
  $('#outerMenu').css('top', -current_scrollY);
  // 検索補助
  // $('header .btnSubmit').removeClass('search-url')
  // $('#menuPanel .btnSubmit').addClass('search-url')
  setTimeout(function () {
    $('html, body').prop({
      scrollTop: 0,
    });
  }, 100);
}

function closeFnc() {
  $('#mainMenu').removeClass('active');
  $('#outerMenu').css('top', '');
  $('#wrapper').removeClass('menuOpen');
  // 検索補助
  // $('header .btnSubmit').addClass('search-url')
  // $('#menuPanel .btnSubmit').removeClass('search-url')
  $('html, body').prop({
    scrollTop: current_scrollY,
  });
}

// ///////ヘッダー制御
function setHeader() {
  var timer = false;
  $(window).on('resize', function () {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $('header').removeClass('fixedHeader');
      $('header').removeClass('fixedHeaderDelay');
    }, 10);
  });

  fixedHeader();
  // console.log($('#mainVis').height())

  $(window).scroll(function () {
    fixedHeader();
  });

  function fixedHeader() {
    if ($('#wrapper').hasClass('home')) {
      h = $('#mainVis').height() - 50;
    } else {
      h = 5;
    }
    baseHeight = h;
    if ($(this).scrollTop() < baseHeight) {
      $('#wrapper').removeClass('fixedHeader');
    } else if ($(this).scrollTop() >= baseHeight) {
      $('#wrapper').addClass('fixedHeader');
    }
  }
}

// テキストアニメーション用span生成
function setSpan() {
  $('.txEffect>span').each(function () {
    var text = $.trim(this.textContent),
      html = '';

    text.split('').forEach(function (v) {
      html += '<span>' + v + '</span>';
    });

    this.innerHTML = html;
  });
}

// ///////waypoint
function setWay() {
  $('.way,.way-slow,.alphaWay,.js-way').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        // scroll down
        activePoint.addClass('is-active');
        timer = setTimeout(function () {
          activePoint.addClass('is-active-after');
        }, 500);
      }
    },
    {
      offset: '70%',
    }
  );
  $('.js-item-way').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        // scroll down
        activePoint.addClass('is-active-item');
        timer = setTimeout(function () {
          activePoint.addClass('is-active-item-after');
        }, 500);
      }
    },
    {
      offset: '70%',
    }
  );
}

// ////////////////////////////アコーディオン
function setAcc() {
  $('.js-toggle .js-ttl').on('click', function () {
    $(this).parent().toggleClass('active');
    $(this).next().stop().slideToggle('fast');
  });
}

// //////////////////////////////ロード完了
function setLoaded() {
  $('#wrapper,#loading').addClass('loaded');
  loadStart();
}

function loadStart() {
  timer = setTimeout(function () {
    $('#wrapper,#loading').addClass('loadedDone');
  }, 200);
  timer = setTimeout(function () {
    $('#wrapper,#loading').addClass('loadedStart');
  }, 600);
  timer = setTimeout(function () {
    $('#wrapper').addClass('loadEnd');
  }, 1500);
  timer = setTimeout(function () {
    $('#wrapper').addClass('homeStart');
  }, 1200);
  if ($('#wrapper').hasClass('home')) {
    timer = setTimeout(function () {
      $('#wrapper').addClass('homeDelay');
    }, 2200);
  } else {
    timer = setTimeout(function () {
      $('#wrapper').addClass('pagesDelay');
    }, 500);
  }
  // $('body,html').animate({
  //   scrollTop: 0
  // }, 0, 'swing')
}

// ////////////ウィンドウサイズを判別
function judgeWinSize() {
  var winW = $(window).width();
  if (winW > breakNum) {
    $('#wrapper').addClass('setPc');
  } else {
    $('#wrapper').addClass('setSp');
  }

  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      winW = $(window).width();
      if (winW > breakNum) {
        $('#wrapper').addClass('setPc');
        $('#wrapper').removeClass('setSp');
      } else {
        $('#wrapper').addClass('setSp');
        $('#wrapper').removeClass('setPc');
      }
    }, 200);
  });
}

//パスワードリマインダー制御
function setPassReminder() {
  $('.remindBtn_01').on('click', function () {
    $('#wrapper').addClass('remind');
    $('main').hide();
  });
  $('.remindBtn_02').on('click', function () {
    $('#wrapper').removeClass('remind');
    $('main').show();
  });
}

// /////////////////////////////スムーススクロール
function setScroll() {
  var headerHeight = $('header').height();
  // var headerHeight = $('header .col-main').height() + 50;
  // if ($('#wrapper').hasClass('setPc')) {
  //   var headerHeight = 0;
  // } else {
  //   var headerHeight = 100;
  // }
  $('a[href^="#"]:not(.passBtn)').click(function (e) {
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    // var position = target.offset().top;

    if ($(this).hasClass('unqNav')) {
      closeFnc();
    }
    setTimeout(function () {
      var position = target.offset().top - headerHeight;
      $('html, body').animate(
        {
          scrollTop: position,
        },
        400,
        'swing'
      );
    }, 100);
    e.preventDefault();
    // $.when(
    //   $('html, body').animate(
    //     {
    //       scrollTop: position,
    //     },
    //     400,
    //     'swing'
    //   ),
    //   e.preventDefault()
    // ).done(function () {
    //   var diff = target.offset().top;
    //   if (diff === position) {
    //   } else {
    //     $('html, body').animate(
    //       {
    //         scrollTop: diff,
    //       },
    //       400,
    //       'swing'
    //     );
    //   }
    // });
  });
}

function startScroll() {
  // ページのURLを取得
  const url = $(location).attr('href'),
    // headerの高さを取得してそれに30px追加した値をheaderHeightに代入
    headerHeight = $('header').outerHeight() + 30;

  // urlに「#」が含まれていれば
  if (url.indexOf('#') != -1) {
    // urlを#で分割して配列に格納
    const anchor = url.split('#'),
      // 分割した最後の文字列（#◯◯の部分）をtargetに代入
      target = $('#' + anchor[anchor.length - 1]),
      // リンク先の位置からheaderHeightの高さを引いた値をpositionに代入
      position = Math.floor(target.offset().top) - headerHeight;
    // positionの位置に移動
    $('html, body').animate({ scrollTop: position }, 500);
  }
  setScroll();
}

// ////////////////////////////////////ランドスケープ判定
var isLandscape = function () {
  if (window.innerHeight > window.innerWidth) {
    jQuery('body').addClass('portrait');
    jQuery('body').removeClass('landscape');
  } else {
    jQuery('body').addClass('landscape');
    jQuery('body').removeClass('portrait');
  }
};

if (_ua.Mobile) {
  jQuery(window).resize(function () {
    isLandscape();
  });
  isLandscape();
}
